import React from 'react';
import { Button, Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { OldContactFields } from './OldContactFields';
import RemoveIcon from '@mui/icons-material/Remove';
import { useFormikContext } from 'formik';

export const MultiContactFields = ({ loading }) => {
	const { values, setFieldValue, isSubmitting } = useFormikContext();
	const { contacts } = values;

	const addContact = () => {
		setFieldValue('contacts', [
			...contacts,
			{
				firstName: '',
				lastName: '',
				emailAddress: '',
				phoneNumber: '',
				phoneNumber2: '',
				dateOfBirth: '',
				isMainContact: false,
				existingContact: false,
				docId: '',
			},
		]);
	};

	const removeContact = (index) => {
		if (contacts.length > 1) {
			const newContacts = contacts.filter((_, i) => i !== index);
			setFieldValue('contacts', newContacts);
		}
	};

	return (
		<>
			{contacts.map((contact, index) => (
				<Grid container spacing={2} key={index}>
					<OldContactFields loading={loading} index={index} hideHeader={true} />
					{contacts.length > 1 && index !== 0 && (
						<Grid size={12}>
							<Button
								disabled={isSubmitting}
								onClick={() => removeContact(index)}
								startIcon={<RemoveIcon />}
							>
								Remove Contact
							</Button>
						</Grid>
					)}
				</Grid>
			))}
			<Grid size={{ xs: 12 }}>
				<Button disabled={isSubmitting} onClick={addContact} startIcon={<AddIcon />}>
					Add additional Contact
				</Button>
			</Grid>
		</>
	);
};
